import { EntityController } from "./EntityController";
import { TulipAssetConstant } from "../TulipAssetConstants";
import { COCOS_PLAN_MODULE_PATH } from "../../constants";
import { PlanManager } from "../../cocosPlan";
import { Commands, ComponentConstants, Staircase, TechnicalElementType } from "@rhinov/savane-js";
import { ARRMGR_CLOUDINARY_ALLOWED, ARRMGR_CLOUDINARY_URL, getFrontUrl, getMediaUrl } from "@rhinov/asset-manager-service";



export class StaircaseEntityController extends EntityController {

        declare entity: Staircase;
        itemStairPreview: string | null = null;
        allModelsForCurrentTechnicalElement: any;
    constructor(entity: Staircase, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.allModelsForCurrentTechnicalElement = TulipAssetConstant.getinstance().getModelList(this.entity);
        this.updatepreviewStair();
        this.updatepreviewTechnicalElement();
    }

    isTechnicalElementModelSelected(modele: any): boolean {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.TechnicalElementType) as TechnicalElementType;

        if (component.technicalElementTypeId === modele._id) {
            return (true);
        }

        return (false);
    };

    openEntityDetail() {
        var path = 'technical-elements/';
        var comp = this.entity.getComponent(ComponentConstants.ComponentType.TechnicalElementType) as TechnicalElementType;
        var id = comp.technicalElementTypeId;
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + id);
            return;
        }
        window.open(getFrontUrl() + path + id);
    };

    updateTechnicalElementModeleType(modele: any) {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.TechnicalElementType);

        if (component !== null) {
            PlanManager.getInstance().executeCommand(new Commands.EditComponentCommand(component, modele._id));
        }
        else {
            PlanManager.getInstance().executeCommand(new Commands.AddComponentCommand(new TechnicalElementType(modele._id), obj, true, false));
        }
        this.itemPreview = this.getTechnicalElementPreviewUrl(modele);
    }

    openAssetDetail(res: any) {
        var path = 'technicalElements/';
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + res._id);
            return;
        }
        window.open(getFrontUrl() + path + res._id);
    };

    getTechnicalElementPreviewUrl(modele: any): string {
        if (modele !== null) {
            var url = getMediaUrl() +
                'technicalElements/' +
                modele._id +
                '/medias/previews/preview1-sm.webp';
            if (ARRMGR_CLOUDINARY_ALLOWED) {
                url = ARRMGR_CLOUDINARY_URL + modele._id + '/medias/previews/preview1-sm.webp';
            }
            return (url);
        }
        else {
            return (COCOS_PLAN_MODULE_PATH + "cocos/resources/loading.gif");
        }
    };

    updatepreviewStair() {
        this.itemStairPreview = getMediaUrl() + 'technicalElements/5cee76bc0ad9e75e7f023643/medias/previews/preview' + (this.entity.materialType + 1) + '-sm.webp';
        if (ARRMGR_CLOUDINARY_ALLOWED) {
            this.itemStairPreview = ARRMGR_CLOUDINARY_URL + '5cee76bc0ad9e75e7f023643/medias/previews/preview' + (this.entity.materialType + 1) + '-sm.webp';
        }
        let preview = document.getElementById('previewStair') as HTMLImageElement;
        if (preview) {
            preview.src = this.itemStairPreview;
        }
    }

    updatepreviewTechnicalElement() {
        var component = this.entity.getComponent(ComponentConstants.ComponentType.TechnicalElementType) as TechnicalElementType;
        if (component !== null) {
            this.itemPreview = getMediaUrl() + 'technicalElements/' + component.technicalElementTypeId + '/medias/previews/preview1-sm.webp';
            if (ARRMGR_CLOUDINARY_ALLOWED) {
                this.itemPreview = ARRMGR_CLOUDINARY_URL + component.technicalElementTypeId + '/medias/previews/preview1-sm.webp';
            }
        }
    }
}